export const DetailsFormJSon = {
  name: "",
  email: "",
  phone: "",
  city: "",
  location: "",
  timeSlot: "",
};

export const DetailsFormJSon_Step2 = {
  Batch_Id: "",
  Course_Id: "",
  Slot: "",
  ClassType:0,
};



export const batches = [
  {
    id: 1,
    course: "670cdc063ac09dd1afe0b5af",
    classType: 1, // 1 = Online
    time: "2:00 PM - 3:00 PM",
    location: "Online",
  },
  {
    id: 2,
    course: "670cdc0a3ac09dd1afe0b5b4",
    classType: 1,
    time: "3:00 PM - 4:00 PM",
    location: "Online",
  },
  {
    id: 3,
    course: "670cdc063ac09dd1afe0b5af",
    classType: 2, // 2 = Offline
    time: "2:00 PM - 3:00 PM",
    location: "Delhi",
  },
  {
    id: 4,
    course: "670cdc0a3ac09dd1afe0b5b4",
    classType: 2,
    time: "3:00 PM - 4:00 PM",
    location: "Delhi",
  },
  {
    id: 5,
    course: "670cdc063ac09dd1afe0b5af",
    classType: 2,
    time: "10:00 AM - 11:00 AM",
    location: "Chandigarh",
  },
  {
    id: 6,
    course: "670cdc0a3ac09dd1afe0b5b4",
    classType: 2,
    time: "11:00 AM - 12:00 PM",
    location: "Chandigarh",
  },
];

export function getBatches(course, classType) {
  
  return batches.filter(
    (batch) =>
      batch.course.toUpperCase() == course.toUpperCase() &&
      batch.classType == classType
  );
}



export const DetailsFormJSon2 = {
  First_Name: "",
  Last_Name: "",
  EmailAddress: "",
  PhoneNo: "",
};

export const ValidatorForm = (data) => {
  let Error = "";
  if (!data?.name) {
    Error += "Name is required !";
  }

  if (
    !data?.email ||
    !data?.email.includes(".") ||
    !data?.email.includes("@")
  ) {
    Error += "Valid Email is required !";
  }

  if (!data?.phone || data?.phone?.length < 10) {
    Error += "Valid Phone No is required !";
  }

  if (!data?.city) {
    Error += "City is required !";
  }

  if (!data?.location) {
    Error += "Location No is required !";
  }

  if (!data?.timeSlot) {
    Error += "Time Slot is required !";
  }

  if (Error) {
    return "Error - " + Error;
  } else {
    return "success";
  }
};

export const ValidatorForm3 = (data) => {
  let Error = "";
  if (!data?.First_Name) {
    Error += "Fisrt Name is required !";
  }

  if (
    !data?.EmailAddress ||
    !data?.EmailAddress.includes(".") ||
    !data?.EmailAddress.includes("@")
  ) {
    Error += "Valid Email is required !";
  }

  if (!data?.PhoneNo || data?.PhoneNo?.length < 10) {
    Error += "Valid Phone No is required !";
  }
  console.log(data);
  if (Error) {
    return "Error - " + Error;
  } else {
    return "success";
  }
};

export const ValidatorForm2 = (data) => {
  let Error = "";
  if (!data?.name) {
    Error += "Name is required !";
  }

  if (
    !data?.email ||
    !data?.email.includes(".") ||
    !data?.email.includes("@")
  ) {
    Error += "Valid Email is required !";
  }

  if (!data?.phone || data?.phone?.length < 10) {
    Error += "Valid Phone No is required !";
  }

  // if (!data?.city) {
  //   Error += "City is required !";
  // }

  // if (!data?.location) {
  //   Error += "Location No is required !";
  // }

  // if (!data?.timeSlot) {
  //   Error += "Time Slot is required !";
  // }

  if (Error) {
    return "Error - " + Error;
  } else {
    return "success";
  }
};
